import React from "react";
import PropTypes from "prop-types";

const SustainabilityAndSystemsIllustration = props => {
  return (
    <svg
      width={props.width}
      height={props.height}
      fill={props.fill}
      style={props.style}
      viewBox="0 0 2000 2000"
    >
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1368.000000,2001.000000 
	C913.500000,2001.000000 459.500000,2000.994507 5.500020,2001.092773 
	C1.750955,2001.093628 0.906737,2000.249023 0.907281,1996.500000 
	C1.003694,1332.833374 1.003694,669.166687 0.907281,5.500014 
	C0.906737,1.751003 1.751000,0.906735 5.500013,0.907280 
	C669.166687,1.003704 1332.833374,1.003704 1996.500000,0.907280 
	C2000.249023,0.906735 2001.093262,1.751001 2001.092651,5.500013 
	C2000.996338,669.166687 2000.996216,1332.833374 2001.092651,1996.500000 
	C2001.093140,2000.249023 2000.249268,2001.095337 1996.500000,2001.093506 
	C1787.166626,2000.988281 1577.833374,2001.000000 1368.000000,2001.000000 
z"
      />
      <path
        fill="#E94E1B"
        opacity="1.000000"
        stroke="none"
        d="
M807.999146,1078.959717 
	C806.348938,1070.034668 804.614502,1061.557495 803.185364,1053.029297 
	C802.714905,1050.222290 801.544373,1048.115967 799.596741,1046.143066 
	C773.847168,1020.058838 748.155701,993.917419 722.417725,967.821716 
	C690.829590,935.794250 659.218201,903.789612 627.586365,871.805298 
	C626.007141,870.208435 625.011169,868.735107 625.078796,866.236023 
	C626.145996,826.788391 627.162231,787.338928 627.963562,747.885193 
	C628.089661,741.678467 631.995239,743.997314 634.736328,744.342834 
	C660.161438,747.548523 685.563049,750.939514 710.980103,754.210022 
	C717.450806,755.042542 719.516785,753.579712 720.352844,747.079773 
	C723.643799,721.494934 726.801819,695.892822 729.963867,670.291565 
	C733.452332,642.047180 736.866150,613.793518 740.358459,585.549622 
	C743.850647,557.306152 747.429443,529.073425 750.916199,500.829285 
	C755.014771,467.629364 759.089111,434.426361 763.059937,401.211060 
	C763.399414,398.371674 764.824341,397.354034 767.258545,396.495453 
	C801.365906,384.465088 836.256470,375.409576 871.863831,369.186188 
	C908.508179,362.781525 945.472534,359.614929 982.667786,359.589081 
	C1050.893433,359.541656 1117.612427,369.569977 1182.591797,390.486816 
	C1280.436523,421.982941 1366.331787,473.516479 1439.861694,545.343079 
	C1530.345337,633.730652 1590.560913,739.484680 1620.347656,862.463196 
	C1630.170532,903.018616 1635.781738,944.190796 1637.429443,985.885010 
	C1642.170288,1105.839966 1616.238403,1218.736450 1559.322266,1324.471191 
	C1558.584717,1325.841553 1558.317993,1327.655884 1556.307129,1328.456177 
	C1550.867676,1296.566528 1545.446289,1264.824829 1540.040771,1233.080566 
	C1533.534790,1194.874634 1527.037109,1156.667358 1520.545532,1118.459106 
	C1515.669922,1089.762573 1510.772217,1061.069702 1505.965942,1032.361694 
	C1504.581177,1024.090820 1502.738892,1022.589783 1494.312622,1023.956482 
	C1483.477905,1025.713623 1472.640381,1027.468384 1461.849243,1029.468262 
	C1459.188354,1029.961426 1458.372192,1029.446899 1458.024902,1026.771484 
	C1452.369141,983.204956 1446.621948,939.650269 1440.895264,896.092896 
	C1440.808472,895.432312 1440.621460,894.767578 1440.649048,894.111877 
	C1441.042847,884.723389 1435.935669,879.105713 1428.484741,874.133850 
	C1416.862183,866.378418 1405.814575,857.755310 1394.609497,849.384644 
	C1391.926147,847.380127 1389.223511,846.513611 1385.846558,846.793152 
	C1373.405396,847.823120 1360.923340,848.411865 1348.507935,849.671997 
	C1344.552490,850.073486 1343.741333,848.902222 1343.539795,845.390808 
	C1342.891602,834.093933 1341.994873,822.811035 1341.153564,811.525757 
	C1340.658447,804.884705 1338.585327,803.011353 1331.778442,804.000671 
	C1310.870850,807.039185 1289.995117,810.296692 1269.107300,813.471436 
	C1266.804810,813.821350 1264.494263,814.130798 1262.205078,814.554443 
	C1255.848267,815.730835 1254.216309,817.822144 1255.137451,824.145996 
	C1256.815674,835.669250 1258.580811,847.181030 1260.444580,858.675720 
	C1261.687622,866.342407 1261.790894,866.320312 1254.456421,868.141968 
	C1244.466064,870.623291 1234.477905,873.113586 1224.207275,875.670105 
	C1222.114746,855.142395 1220.062988,834.953735 1217.995850,814.766541 
	C1217.080322,805.824768 1216.233887,796.874146 1215.161011,787.950989 
	C1214.553589,782.899536 1211.979126,780.969055 1207.052124,781.465576 
	C1172.272827,784.970398 1137.494751,788.486389 1102.718994,792.026428 
	C1097.527710,792.554932 1095.415039,794.900085 1095.921265,800.425964 
	C1097.637573,819.158386 1099.549194,837.873169 1101.434326,856.589844 
	C1104.269897,884.742432 1107.152466,912.890137 1110.001709,941.041321 
	C1111.108032,951.972229 1112.087646,962.917114 1113.327637,973.832520 
	C1113.641846,976.597290 1112.864990,977.531494 1110.169312,978.188782 
	C1101.002686,980.423828 1100.923096,980.576294 1099.468994,971.268066 
	C1097.851440,960.912170 1096.375732,950.531738 1095.020142,940.138306 
	C1094.403687,935.412842 1092.110107,933.050232 1087.259155,932.821533 
	C1045.863281,930.870056 1004.431030,929.419495 963.098022,926.548035 
	C947.272156,925.448608 933.139221,927.991882 918.786743,934.427246 
	C895.747009,944.757996 872.121704,953.782349 848.746643,963.365662 
	C842.110291,966.086487 841.327881,967.747253 842.519043,974.835999 
	C850.732422,1023.718018 858.915466,1072.605103 867.051086,1121.500122 
	C868.574829,1130.657227 868.448975,1130.629639 859.073914,1132.061401 
	C852.828430,1133.015259 846.598694,1134.079346 840.377686,1135.183105 
	C834.837219,1136.166138 832.957153,1138.595093 833.900818,1144.277710 
	C838.041504,1169.212158 842.323547,1194.123047 846.540283,1219.044922 
	C846.843506,1220.837036 847.034607,1222.648071 846.836548,1224.666016 
	C839.634155,1216.803955 831.773010,1210.179443 829.778564,1198.151367 
	C823.196106,1158.453125 815.377747,1118.959839 807.999146,1078.959717 
z"
      />
      <path
        fill="#E94E1B"
        opacity="1.000000"
        stroke="none"
        d="
M1214.984497,1579.355469 
	C1225.941772,1579.800537 1236.555176,1582.708008 1247.354736,1584.504517 
	C1257.030151,1586.114136 1266.631836,1588.162598 1276.290771,1589.877686 
	C1282.352173,1590.953979 1284.198608,1589.792480 1286.441284,1583.862061 
	C1290.027100,1574.379639 1293.612671,1564.896240 1297.083252,1555.371216 
	C1299.224976,1549.493286 1297.815674,1546.739868 1291.901611,1544.805542 
	C1249.411865,1530.907715 1206.917480,1517.023926 1164.427246,1503.127686 
	C1162.106934,1502.368774 1159.810547,1501.536621 1157.613159,1500.127197 
	C1167.804565,1500.644409 1178.008423,1500.993408 1188.181519,1501.754272 
	C1192.813721,1502.100830 1195.726440,1500.570190 1197.759521,1496.400269 
	C1203.661499,1484.296021 1209.781006,1472.297974 1215.771362,1460.236328 
	C1219.514648,1452.699585 1216.905396,1448.366333 1208.429565,1448.172241 
	C1183.292847,1447.596680 1158.154419,1447.097656 1133.016846,1446.557007 
	C1102.222900,1445.894653 1071.428101,1445.259888 1040.636597,1444.497437 
	C1037.104370,1444.409912 1034.276123,1445.321899 1031.466064,1447.467529 
	C1019.025391,1456.966675 1006.455811,1466.296875 993.924377,1475.677124 
	C993.161743,1476.248047 992.326965,1476.722656 991.440063,1477.297485 
	C990.589539,1475.456055 992.026367,1474.671509 992.710388,1473.708862 
	C1001.968018,1460.680908 1011.277771,1447.690063 1020.562256,1434.681152 
	C1024.925903,1428.567139 1024.793457,1426.873901 1019.818665,1421.246948 
	C968.860107,1363.605347 917.913696,1305.952881 866.944763,1248.320435 
	C865.247253,1246.401001 864.213135,1244.385132 863.769958,1241.755371 
	C858.683533,1211.576416 853.472351,1181.418335 848.222473,1151.267212 
	C847.736755,1148.477417 848.089478,1147.257935 851.370117,1146.712646 
	C881.884399,1141.640137 912.354736,1136.303833 942.848938,1131.109375 
	C986.794250,1123.623535 1030.752441,1116.213135 1074.698608,1108.732422 
	C1120.946045,1100.860107 1167.184937,1092.937988 1213.429077,1085.046265 
	C1265.732300,1076.120239 1318.036377,1067.197998 1370.341919,1058.285400 
	C1409.686890,1051.581299 1449.042236,1044.937012 1488.370728,1038.137939 
	C1492.385376,1037.443848 1493.624268,1038.397949 1494.321289,1042.584351 
	C1502.759521,1093.270020 1511.441650,1143.915161 1520.087646,1194.566284 
	C1530.608276,1256.198975 1541.185913,1317.821777 1551.680908,1379.458740 
	C1560.529053,1431.424683 1569.294189,1483.404663 1578.096436,1535.378296 
	C1578.484985,1537.672974 1578.514648,1540.107910 1579.340576,1542.233032 
	C1581.302246,1547.281128 1578.788818,1548.269531 1574.464966,1548.999634 
	C1498.692871,1561.794678 1422.943726,1574.724731 1347.184692,1587.597046 
	C1318.486938,1592.473145 1289.771484,1597.245239 1261.083740,1602.179443 
	C1258.782349,1602.575317 1256.926636,1602.317505 1254.928223,1601.230469 
	C1241.640747,1594.002441 1228.314331,1586.846558 1214.984497,1579.355469 
z"
      />
      <path
        fill="#E94E1C"
        opacity="1.000000"
        stroke="none"
        d="
M669.697998,933.299683 
	C708.917175,973.042664 747.856995,1012.564636 786.915527,1051.968750 
	C789.857788,1054.937012 790.814819,1058.309448 791.518311,1062.125977 
	C799.264526,1104.149292 807.077942,1146.160156 814.893616,1188.284912 
	C812.989502,1188.121582 812.459595,1186.554443 811.555054,1185.532471 
	C784.734985,1155.226685 757.992493,1124.851929 731.075623,1094.632324 
	C728.400452,1091.628906 727.766602,1090.091797 731.510986,1087.564209 
	C736.049866,1084.500488 740.114197,1080.732788 744.378052,1077.262451 
	C750.649658,1072.157715 750.901245,1069.542969 745.472473,1063.330444 
	C725.963745,1041.004883 706.409668,1018.719177 686.887390,996.405457 
	C652.779114,957.420288 618.614929,918.483459 584.662415,879.363037 
	C580.305969,874.343384 576.377625,872.013733 569.310364,873.915039 
	C526.128418,885.532776 482.818054,896.673279 439.555420,907.991821 
	C432.690247,909.787903 431.742737,910.884583 432.029266,918.044495 
	C433.519775,955.288879 435.101685,992.529663 436.663239,1029.771240 
	C437.032593,1038.580933 437.635895,1047.386230 437.748627,1056.198608 
	C437.795685,1059.875977 439.103821,1062.453125 441.667816,1064.900757 
	C468.897827,1090.893677 496.071289,1116.945923 523.250732,1142.991699 
	C542.372559,1161.315918 561.497131,1179.637451 580.582336,1197.999634 
	C586.045837,1203.256104 588.201782,1203.424072 594.205261,1198.603271 
	C597.842346,1195.682861 601.576294,1192.869385 605.054565,1189.769653 
	C607.152283,1187.900391 608.390381,1188.207886 610.351440,1190.088501 
	C636.670044,1215.329712 663.064514,1240.491943 689.474304,1265.637939 
	C734.089722,1308.118530 778.732727,1350.569824 823.356689,1393.041504 
	C834.453979,1403.603516 845.517944,1414.200806 856.609680,1424.768677 
	C858.205627,1426.289429 859.444946,1427.904541 859.868103,1430.203979 
	C868.565735,1477.478271 877.309875,1524.744019 886.055176,1572.009521 
	C890.018677,1593.430664 893.912048,1614.865601 898.065247,1636.250000 
	C898.812927,1640.099609 898.039185,1640.934326 894.134644,1640.929321 
	C807.474548,1640.816772 720.814148,1640.807129 634.154114,1640.959229 
	C630.194580,1640.966187 629.098450,1639.278931 628.095581,1636.131470 
	C600.445862,1549.357666 572.514648,1462.672729 545.221008,1375.787354 
	C539.551880,1357.740356 530.020996,1341.868042 521.160645,1325.559814 
	C480.742706,1251.167725 440.111725,1176.891479 399.574921,1102.563965 
	C398.403442,1100.415894 397.213165,1098.403076 397.361359,1095.622437 
	C398.822998,1068.198486 400.104523,1040.764893 401.445557,1013.334595 
	C403.339294,974.599426 405.300476,935.867310 407.043060,897.125366 
	C407.213531,893.335266 408.149323,891.721619 412.072296,890.799377 
	C468.565460,877.518433 525.023438,864.086792 581.441956,850.492004 
	C585.547974,849.502563 588.037476,850.232422 590.948425,853.213989 
	C617.019653,879.918823 643.258606,906.459900 669.697998,933.299683 
z"
      />
      <path
        fill="#E94E1B"
        opacity="1.000000"
        stroke="none"
        d="
M487.281769,711.834229 
	C477.273163,710.513916 467.721985,709.106567 458.131866,708.053528 
	C455.058136,707.716064 454.039948,706.742249 453.784515,703.554932 
	C450.047577,656.922424 447.408264,610.246216 446.788757,563.452637 
	C446.319092,527.975769 446.429688,492.529449 450.120453,457.204865 
	C451.605804,442.988617 453.705475,428.856476 458.632172,415.273285 
	C461.752838,406.669495 467.394409,401.068054 475.894470,397.867828 
	C490.824310,392.246796 506.429230,389.846924 522.127747,388.078156 
	C576.203247,381.985443 630.499207,382.461914 684.780029,383.241241 
	C705.404541,383.537354 726.013367,384.834045 746.635254,385.489075 
	C750.532532,385.612885 751.852417,386.285583 751.279297,390.785461 
	C744.447083,444.426392 737.864990,498.099274 731.254395,551.768311 
	C725.436890,598.999268 719.671997,646.236816 713.871216,693.469849 
	C712.127014,707.671631 710.252625,721.858215 708.636536,736.074341 
	C708.241455,739.549805 707.384888,740.696594 703.478210,740.158569 
	C674.143311,736.118774 644.766846,732.379944 615.403687,728.545288 
	C585.875732,724.689209 556.348328,720.829407 526.820190,716.974792 
	C513.788818,715.273621 500.756195,713.581116 487.281769,711.834229 
z"
      />
      <path
        fill="#E94F1C"
        opacity="1.000000"
        stroke="none"
        d="
M330.000366,1030.991821 
	C329.244690,996.810059 330.793610,963.233032 335.160187,929.823669 
	C343.885284,863.066040 362.340759,799.112488 390.850159,738.086121 
	C403.400513,711.221313 417.642517,685.296265 433.783020,660.419617 
	C434.664001,659.061829 435.185883,657.400024 437.161133,656.275330 
	C437.727478,663.632446 438.293945,670.731506 438.815979,677.833923 
	C439.584839,688.293396 440.339447,698.754028 441.067230,709.216431 
	C441.679718,718.021606 442.536652,719.002380 451.164215,720.202393 
	C456.438019,720.935913 461.716125,721.646790 467.004028,722.267578 
	C469.556305,722.567139 470.635559,723.406128 470.460419,726.384216 
	C467.831635,771.078735 465.326813,815.780762 462.890320,860.486267 
	C462.703278,863.918701 461.833130,865.636108 458.031067,866.490051 
	C439.058350,870.751160 420.199493,875.516663 401.250854,879.889221 
	C396.789581,880.918701 394.734283,883.198364 394.522736,887.724609 
	C393.256348,914.822876 391.891022,941.916565 390.561127,969.011841 
	C388.562195,1009.738403 386.739807,1050.475098 384.403076,1091.182373 
	C383.991455,1098.353027 385.387543,1104.319580 388.792114,1110.537354 
	C434.554596,1194.114746 480.173737,1277.770630 525.709778,1361.471680 
	C530.977966,1371.155396 533.124939,1382.072510 536.488892,1392.483398 
	C550.692688,1436.442017 564.675171,1480.472168 578.727417,1524.479736 
	C578.872681,1524.934570 578.866638,1525.437866 579.075378,1526.991577 
	C574.574890,1523.380615 570.651489,1520.336548 566.839478,1517.158813 
	C495.516968,1457.702393 438.957397,1386.523682 397.608490,1303.370361 
	C368.003387,1243.833984 348.102173,1181.171997 337.792847,1115.451538 
	C333.426208,1087.614990 330.969757,1059.628296 330.000366,1030.991821 
z"
      />
      <path
        fill="#E94E1B"
        opacity="1.000000"
        stroke="none"
        d="
M656.384277,1131.374146 
	C634.610779,1148.981934 613.067993,1166.309082 591.664185,1183.806152 
	C588.737366,1186.198608 587.154602,1186.019897 584.418030,1183.388184 
	C541.460022,1142.075073 498.422546,1100.843994 455.214172,1059.793091 
	C451.668335,1056.424194 450.618622,1052.851318 450.448730,1048.452515 
	C449.600861,1026.495972 448.750397,1004.539490 447.839569,982.585449 
	C447.039276,963.295349 446.257599,944.003235 445.220428,924.725281 
	C445.034424,921.267761 445.810669,919.837158 449.295288,918.942017 
	C489.218567,908.686584 529.112915,898.316650 568.958557,887.764343 
	C572.486389,886.830078 574.303833,887.688171 576.531311,890.238953 
	C627.576965,948.693542 678.685608,1007.093079 729.877319,1065.419800 
	C732.458435,1068.360718 732.913147,1069.779541 729.426880,1072.551025 
	C705.049927,1091.930908 680.888977,1111.582520 656.384277,1131.374146 
z"
      />
      <path
        fill="#E94F1C"
        opacity="1.000000"
        stroke="none"
        d="
M628.171936,1171.174072 
	C656.809082,1148.025635 685.236328,1125.182251 713.448914,1102.076782 
	C717.009094,1099.161133 718.418213,1100.017212 721.052612,1103.005737 
	C778.188599,1167.819092 835.440613,1232.530151 892.656555,1297.272949 
	C930.471375,1340.062256 968.252014,1382.881836 1006.107483,1425.635254 
	C1007.896423,1427.655640 1008.469238,1429.012817 1006.677246,1431.498535 
	C990.615234,1453.779053 974.634949,1476.119751 958.819702,1498.575806 
	C956.505554,1501.861572 955.186401,1500.515381 953.212341,1498.628662 
	C928.293274,1474.814819 903.363586,1451.011963 878.404480,1427.240112 
	C826.678589,1377.974609 774.927246,1328.735718 723.198181,1279.473389 
	C690.885315,1248.701294 658.594910,1217.905762 626.291992,1187.123169 
	C623.643250,1184.599121 620.976013,1182.094604 618.109924,1179.384888 
	C621.467163,1176.645142 624.681641,1174.021973 628.171936,1171.174072 
z"
      />
      <path
        fill="#E94F1C"
        opacity="1.000000"
        stroke="none"
        d="
M1156.995850,1460.156494 
	C1170.639282,1460.489502 1183.782349,1460.906616 1196.928589,1461.093872 
	C1200.065063,1461.138672 1200.217896,1462.016357 1198.931763,1464.491821 
	C1195.713867,1470.686035 1192.387085,1476.847534 1189.633057,1483.249634 
	C1187.937744,1487.190674 1185.784058,1488.464722 1181.435791,1488.227295 
	C1157.179077,1486.902344 1132.900269,1485.988159 1108.636963,1484.775024 
	C1104.295898,1484.557739 1100.816528,1485.269531 1100.016113,1490.084961 
	C1099.222412,1494.858765 1102.321411,1496.771851 1106.385620,1498.094360 
	C1163.423462,1516.654663 1220.413696,1535.361450 1277.500366,1553.769775 
	C1282.382446,1555.343994 1283.070801,1557.183105 1280.938721,1561.313354 
	C1279.801147,1563.516602 1279.072632,1565.933228 1278.184937,1568.263306 
	C1275.122925,1576.300659 1275.121948,1576.329956 1266.903931,1574.812378 
	C1236.166382,1569.135864 1205.432373,1563.439453 1174.697021,1557.751099 
	C1168.676514,1556.636841 1165.597290,1557.780640 1164.497925,1561.848755 
	C1163.132568,1566.901001 1166.656494,1568.951538 1170.338989,1570.918823 
	C1201.722168,1587.684082 1233.093872,1604.470581 1264.440308,1621.303955 
	C1265.987549,1622.134888 1267.949341,1622.496460 1269.000122,1624.604126 
	C1251.654297,1634.455200 1234.335327,1644.294189 1217.013550,1654.128052 
	C1191.269165,1668.743896 1165.490845,1683.300171 1139.820068,1698.044189 
	C1136.796509,1699.780762 1135.307861,1699.566162 1132.919067,1696.898071 
	C1078.727295,1636.370117 1024.429077,1575.937378 970.059692,1515.568970 
	C967.716492,1512.967285 967.553406,1511.835083 970.539795,1509.622070 
	C992.744019,1493.168335 1014.842834,1476.571045 1036.853638,1459.859253 
	C1039.682251,1457.711426 1042.416016,1457.682739 1045.661865,1457.766357 
	C1068.127319,1458.346313 1090.598389,1458.699585 1113.067017,1459.162964 
	C1127.544312,1459.461426 1142.020142,1459.823120 1156.995850,1460.156494 
z"
      />
      <path
        fill="#E94E1B"
        opacity="1.000000"
        stroke="none"
        d="
M1081.822266,946.081970 
	C1084.447998,960.886902 1086.778442,975.484131 1088.918457,990.109253 
	C1093.542725,1021.709900 1098.031372,1053.330444 1102.686035,1084.926636 
	C1103.242798,1088.706543 1103.140381,1090.616699 1098.337158,1091.409058 
	C1051.738647,1099.095703 1005.196533,1107.125244 958.639465,1115.063110 
	C934.384521,1119.198364 910.116150,1123.259277 885.894836,1127.583374 
	C882.342102,1128.217407 881.431946,1127.484131 880.851501,1123.973633 
	C872.848877,1075.572754 864.703857,1027.195190 856.454163,978.835693 
	C855.941650,975.831726 856.360840,974.413879 859.320190,973.211731 
	C886.262756,962.267090 913.159058,951.207764 940.020447,940.065247 
	C943.627930,938.568787 947.226746,939.024658 950.831665,939.197266 
	C986.402161,940.900635 1021.969421,942.670898 1057.535767,944.459473 
	C1065.507812,944.860352 1073.472412,945.407288 1081.822266,946.081970 
z"
      />
      <path
        fill="#E94F1C"
        opacity="1.000000"
        stroke="none"
        d="
M1294.059814,1057.997437 
	C1278.219116,1060.679077 1262.802246,1063.290894 1247.403442,1066.004761 
	C1244.505859,1066.515381 1243.306396,1065.864746 1242.990479,1062.648193 
	C1238.354492,1015.438660 1233.595703,968.241089 1228.843750,921.042908 
	C1228.060059,913.259583 1227.205688,905.482849 1226.315186,897.710938 
	C1225.759277,892.860229 1228.778198,888.189026 1233.602417,886.963928 
	C1245.204712,884.017639 1256.839233,881.198975 1268.442871,878.257385 
	C1274.859985,876.630615 1276.045532,874.997986 1275.106689,868.317566 
	C1273.347168,855.797180 1271.530640,843.280090 1269.396240,830.820129 
	C1268.812622,827.413879 1269.778931,826.526611 1272.898804,826.072266 
	C1290.017822,823.579163 1307.124146,820.990417 1324.203613,818.240356 
	C1327.741699,817.670593 1328.801270,818.543030 1328.957153,822.171753 
	C1329.435425,833.309753 1330.310913,844.430908 1331.043823,855.557800 
	C1331.436035,861.511963 1333.764526,863.702148 1339.601318,863.293884 
	C1353.051270,862.352905 1366.506958,861.450439 1379.932129,860.223450 
	C1384.337280,859.820740 1387.807251,860.650330 1391.401978,863.424011 
	C1401.812622,871.457031 1412.518066,879.110413 1423.173950,886.821472 
	C1425.591675,888.570984 1426.857300,890.476562 1427.269897,893.651245 
	C1433.015747,937.874146 1438.921021,982.076538 1444.920288,1026.265991 
	C1445.515137,1030.647217 1445.066284,1033.105835 1439.794067,1033.252197 
	C1435.514526,1033.370850 1431.173584,1034.265991 1427.031250,1035.427734 
	C1423.579956,1036.395752 1422.746582,1035.093872 1422.302612,1032.101562 
	C1419.592041,1013.835144 1416.775146,995.584595 1414.004150,977.327148 
	C1410.634399,955.124451 1407.299194,932.916443 1403.891602,910.719666 
	C1403.177002,906.064758 1400.574951,903.966980 1395.848999,904.631042 
	C1380.858398,906.737244 1365.884766,908.973083 1350.930542,911.324097 
	C1345.719727,912.143250 1344.032349,914.586426 1344.859131,920.264893 
	C1347.639282,939.360046 1350.595947,958.429443 1353.495239,977.507263 
	C1356.819580,999.381958 1360.073364,1021.268066 1363.576050,1043.114258 
	C1364.081055,1046.263672 1362.392334,1046.458130 1360.417358,1046.793579 
	C1340.247559,1050.218018 1320.071777,1053.607178 1299.898193,1057.009888 
	C1298.093262,1057.314453 1296.292603,1057.644653 1294.059814,1057.997437 
z"
      />
      <path
        fill="#E94E1B"
        opacity="1.000000"
        stroke="none"
        d="
M1116.924683,878.176331 
	C1114.570801,854.873413 1112.326782,832.018311 1109.874268,809.185547 
	C1109.484009,805.552979 1110.308105,804.327393 1114.121582,803.964905 
	C1142.449341,801.272400 1170.756348,798.359863 1199.058105,795.402771 
	C1201.732422,795.123413 1202.872681,795.434326 1203.169678,798.486755 
	C1206.022705,827.802490 1209.028198,857.103394 1212.014893,886.406006 
	C1215.204224,917.697144 1218.445801,948.982971 1221.618164,980.275818 
	C1224.454834,1008.257141 1227.158813,1036.252319 1230.115234,1064.220825 
	C1230.495850,1067.821533 1229.595337,1069.117798 1226.038086,1069.706909 
	C1198.143555,1074.328003 1170.266479,1079.057861 1142.416992,1083.942505 
	C1138.567383,1084.617676 1137.533447,1083.380981 1137.185791,1079.810791 
	C1133.830444,1045.360352 1130.381226,1010.919189 1126.895264,976.481689 
	C1123.744263,945.354309 1120.512573,914.235046 1117.323242,883.111450 
	C1117.170532,881.621582 1117.083374,880.125000 1116.924683,878.176331 
z"
      />
      <path
        fill="#E94F1C"
        opacity="1.000000"
        stroke="none"
        d="
M557.718384,842.756104 
	C530.336487,849.233765 503.358704,855.605774 475.856476,862.101624 
	C476.304230,853.372375 476.691620,845.088928 477.160278,836.810059 
	C479.182281,801.091492 481.301300,765.378052 483.170532,729.651550 
	C483.398285,725.298523 484.875061,724.550903 488.859528,725.083313 
	C529.591492,730.526367 570.340454,735.843872 611.098755,741.086121 
	C614.262573,741.493042 615.150818,742.700684 615.064087,745.831787 
	C614.159912,778.445496 613.413025,811.063477 612.576477,843.679138 
	C612.483215,847.317993 613.014526,851.007996 611.698853,855.530884 
	C606.656616,850.407288 601.685730,845.890320 597.369690,840.816284 
	C593.261292,835.986511 588.903442,834.801697 582.826416,836.631592 
	C574.722473,839.071838 566.368835,840.683044 557.718384,842.756104 
z"
      />
      <path
        fill="#E94F1C"
        opacity="1.000000"
        stroke="none"
        d="
M1031.404175,1603.588379 
	C1041.149536,1614.432373 1050.651978,1625.020508 1060.739624,1636.260498 
	C1047.186401,1638.599609 1034.621094,1640.787476 1022.048950,1642.933716 
	C994.998352,1647.552002 967.928955,1652.063354 940.905762,1656.835938 
	C936.214478,1657.664429 934.269836,1657.242554 933.367737,1651.703369 
	C926.497559,1609.517456 919.170471,1567.406128 911.991333,1525.270508 
	C909.170166,1508.712402 906.359802,1492.152344 903.555542,1475.591431 
	C903.253967,1473.810303 903.025269,1472.016968 902.656006,1469.502686 
	C950.409851,1510.108398 989.822266,1557.646973 1031.404175,1603.588379 
z"
      />
      <path
        fill="#E94F1C"
        opacity="1.000000"
        stroke="none"
        d="
M1377.548828,920.605591 
	C1382.420898,920.073547 1387.788208,917.129272 1390.984619,919.374878 
	C1394.191895,921.628113 1393.165527,927.651306 1393.841553,932.022583 
	C1399.098877,966.013245 1404.124390,1000.039978 1409.454102,1034.019043 
	C1410.015625,1037.599976 1409.328613,1038.601807 1405.838867,1039.071899 
	C1397.445679,1040.202515 1389.047363,1041.482422 1380.784058,1043.304688 
	C1377.004883,1044.138062 1376.575684,1042.490967 1376.164307,1039.723267 
	C1373.451660,1021.478943 1370.714478,1003.238342 1367.939209,985.003479 
	C1365.114380,966.443115 1362.302979,947.880188 1359.329468,929.343384 
	C1358.701172,925.426208 1358.353149,922.652710 1363.809570,922.586731 
	C1368.253296,922.532959 1372.683594,921.374695 1377.548828,920.605591 
z"
      />
      <path
        fill="#EA5320"
        opacity="1.000000"
        stroke="none"
        d="
M898.216797,1565.821167 
	C891.605957,1530.083374 885.072083,1494.768555 878.546326,1459.452393 
	C877.617432,1454.425171 876.727539,1449.390869 875.783569,1444.160645 
	C885.983337,1448.868164 887.374451,1457.918213 888.939087,1467.222290 
	C899.443176,1529.685547 910.125122,1592.118896 920.790833,1654.554810 
	C922.544312,1664.819580 922.614685,1665.028198 912.484619,1663.946167 
	C892.653687,1661.828125 872.961060,1658.747070 853.397827,1654.204224 
	C855.005615,1654.132324 856.613403,1653.999878 858.221313,1653.998169 
	C873.714600,1653.982300 889.207947,1654.015503 904.701111,1653.976074 
	C911.592041,1653.958496 914.130493,1651.015259 912.870483,1644.192627 
	C908.070129,1618.198975 903.163452,1592.225098 898.216797,1565.821167 
z"
      />
      <path
        fill="#EA5320"
        opacity="1.000000"
        stroke="none"
        d="
M1001.609741,1659.749512 
	C1024.134277,1655.852173 1046.234131,1652.048340 1068.339600,1648.277466 
	C1069.591919,1648.063721 1070.956543,1647.544800 1072.061279,1648.796875 
	C1075.307251,1652.475464 1078.570435,1656.139038 1082.371216,1660.422119 
	C1041.621216,1666.545898 1001.583069,1668.820923 961.146606,1666.584717 
	C974.493164,1664.339722 987.839722,1662.094849 1001.609741,1659.749512 
z"
      />
      <path
        fill="#E9511E"
        opacity="1.000000"
        stroke="none"
        d="
M1118.244385,1022.590698 
	C1120.388306,1043.375854 1122.415527,1063.715942 1124.596558,1084.039429 
	C1125.122681,1088.942017 1121.089844,1086.856689 1119.170410,1087.769043 
	C1116.945068,1088.826538 1116.190308,1087.330444 1115.864624,1085.050537 
	C1111.682129,1055.778198 1107.411987,1026.518188 1103.078247,997.267761 
	C1102.661377,994.454346 1103.296387,993.212097 1106.268066,992.479126 
	C1115.386475,990.229919 1115.270874,990.084412 1116.013062,999.306824 
	C1116.626221,1006.926636 1117.452515,1014.529236 1118.244385,1022.590698 
z"
      />
      <path
        fill="#E94E1B"
        opacity="1.000000"
        stroke="none"
        d="
M1215.031738,1578.973389 
	C1215.053467,1578.950439 1214.636230,1578.849487 1214.636230,1578.849487 
	C1214.636230,1578.849487 1214.956909,1578.799561 1214.962646,1578.921631 
	C1214.968506,1579.043701 1215.010010,1578.996216 1215.031738,1578.973389 
z"
      />
      <path
        fill="#FFFDFC"
        opacity="1.000000"
        stroke="none"
        d="
M1182.998535,1349.995605 
	C1186.993286,1350.047729 1190.516113,1349.846924 1193.976685,1350.222168 
	C1197.478516,1350.601807 1197.869263,1349.369873 1197.017334,1346.365601 
	C1194.117065,1336.136230 1191.382690,1325.859497 1188.595093,1315.598267 
	C1188.388062,1314.836060 1188.260864,1314.052124 1187.924194,1312.467651 
	C1195.509521,1317.042603 1202.445190,1321.198486 1209.354004,1325.398560 
	C1221.573853,1332.827393 1233.777832,1340.282104 1245.986450,1347.729248 
	C1247.766235,1348.814819 1250.030518,1349.380371 1248.497925,1352.513672 
	C1238.428833,1373.098389 1228.490723,1393.747070 1218.497559,1414.369141 
	C1218.449097,1414.468872 1218.224854,1414.483276 1217.564453,1414.734985 
	C1214.803101,1404.533203 1211.814697,1394.433105 1209.432617,1384.192017 
	C1208.574463,1380.502563 1207.030151,1379.886963 1203.674805,1380.145752 
	C1184.936890,1381.592041 1166.178467,1382.774170 1147.441772,1384.235474 
	C1144.429321,1384.470581 1142.472656,1383.515747 1140.516724,1381.410400 
	C1133.041870,1373.364868 1125.465454,1365.412842 1117.852539,1357.497437 
	C1116.621216,1356.217163 1116.031372,1354.973755 1115.945435,1353.159790 
	C1115.173462,1336.880371 1114.364380,1320.601685 1113.359985,1304.335449 
	C1113.170288,1301.264526 1114.131714,1300.666260 1116.923218,1300.953125 
	C1128.505859,1302.143188 1140.098511,1303.247314 1151.700562,1304.227661 
	C1154.786865,1304.488647 1154.915039,1306.240356 1154.882812,1308.632568 
	C1154.721436,1320.615845 1154.826660,1332.605225 1154.474854,1344.581787 
	C1154.355591,1348.638794 1155.722778,1349.591431 1159.550903,1349.527222 
	C1167.195557,1349.398682 1174.849243,1349.807983 1182.998535,1349.995605 
z"
      />
      <path
        fill="#FFFDFD"
        opacity="1.000000"
        stroke="none"
        d="
M1170.163940,1191.099365 
	C1172.229980,1186.880371 1174.562866,1183.146484 1175.947021,1179.089111 
	C1177.828491,1173.574341 1181.349731,1171.121460 1186.981201,1170.061646 
	C1196.449951,1168.280029 1205.792847,1165.807617 1215.149658,1163.469971 
	C1217.231934,1162.949707 1218.970337,1163.037109 1220.874634,1164.017456 
	C1235.216797,1171.401123 1249.557129,1178.790405 1263.990601,1185.992554 
	C1266.889160,1187.438721 1267.031982,1188.497681 1265.149048,1191.034790 
	C1258.402100,1200.126221 1251.795654,1209.327393 1245.365356,1218.645142 
	C1243.635986,1221.151245 1242.337891,1221.447754 1239.769409,1219.898071 
	C1229.085327,1213.450806 1218.232788,1207.282471 1207.563232,1200.811890 
	C1205.095337,1199.315186 1204.106079,1199.681030 1202.677490,1202.093384 
	C1196.572998,1212.402100 1190.345459,1222.642578 1183.924561,1232.756714 
	C1181.838623,1236.042358 1182.974731,1236.707153 1186.129395,1237.493896 
	C1197.092529,1240.227905 1207.987305,1243.235962 1219.870728,1246.395630 
	C1214.364258,1249.455444 1209.556885,1252.160278 1204.718628,1254.808960 
	C1189.691650,1263.035645 1174.657349,1271.248657 1159.612305,1279.442261 
	C1158.137085,1280.245728 1156.757324,1281.865601 1155.063721,1279.370361 
	C1141.986816,1260.104370 1128.820068,1240.899292 1114.974365,1220.641235 
	C1125.596924,1223.502319 1135.208984,1225.799072 1144.616943,1228.747437 
	C1149.402466,1230.247070 1151.807739,1229.612671 1153.974731,1224.678833 
	C1158.917969,1213.423218 1164.616333,1202.499146 1170.163940,1191.099365 
z"
      />
      <path
        fill="#FFFEFD"
        opacity="1.000000"
        stroke="none"
        d="
M1299.030518,1325.063477 
	C1307.911865,1320.072632 1307.912476,1320.072266 1303.277710,1311.555908 
	C1298.507202,1302.790039 1293.618896,1294.085205 1289.027832,1285.226440 
	C1287.423950,1282.131714 1286.328491,1282.322266 1284.132446,1284.617188 
	C1277.222290,1291.838623 1270.143677,1298.899170 1263.111572,1306.003418 
	C1262.112183,1307.012939 1261.009766,1307.920532 1259.997437,1308.836792 
	C1259.997437,1297.321045 1259.887451,1286.093384 1260.028564,1274.868652 
	C1260.168823,1263.715942 1260.541626,1252.565796 1260.862305,1241.415894 
	C1260.920898,1239.373901 1260.415405,1237.209351 1263.893921,1236.968140 
	C1285.979736,1235.437500 1308.050171,1233.687866 1330.126587,1232.021362 
	C1330.921631,1231.961304 1331.725098,1232.013672 1333.817993,1232.013672 
	C1327.993286,1237.841309 1322.872803,1242.910522 1317.815918,1248.042603 
	C1314.554199,1251.352905 1309.422852,1254.394897 1308.721802,1258.216064 
	C1308.006958,1262.113037 1313.052124,1265.963989 1315.598145,1269.808594 
	C1324.237549,1282.855835 1332.970703,1295.843018 1341.855835,1308.723511 
	C1343.467041,1311.059204 1343.654785,1313.081177 1342.882324,1315.611450 
	C1339.680786,1326.098267 1336.577881,1336.615234 1333.419556,1347.115234 
	C1332.997192,1348.519287 1332.851562,1350.039795 1331.400269,1350.975586 
	C1316.462646,1360.607910 1301.543945,1370.269165 1286.389526,1380.071411 
	C1280.913330,1368.083862 1275.653320,1356.424438 1270.241943,1344.835571 
	C1269.041626,1342.264771 1270.313721,1341.354858 1272.233398,1340.275757 
	C1281.081421,1335.302856 1289.881836,1330.245239 1299.030518,1325.063477 
z"
      />
    </svg>
  );
};

SustainabilityAndSystemsIllustration.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
  style: PropTypes.object,
  fill: PropTypes.string,
};

SustainabilityAndSystemsIllustration.defaultProps = {
  width: 292,
  height: 292,
  fill: "none",
  style: {},
};

export default SustainabilityAndSystemsIllustration;
